import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TextArea} from "../../../../model/layout.model";
import { CharacterCounterComponent } from '../character-counter/character-counter.component';
import {AsyncPipe, NgIf} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {LayoutElementUtil} from "../../../../service/layout/layout-element.service";
import {MatIconModule} from "@angular/material/icon";
import {ProgressBarModel, ProgressbarService} from "../../../../service/progressbar.service";
import {Observable} from "rxjs";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {EventBusService} from "../../../../service/event-bus.service";
import {KiRefreshEvent} from "../../../../model/event-bus.model";
import {EventBusTypes} from "../../../../model/constants";

@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    styleUrls: ['./text-area.component.scss'],
    standalone: true,
  imports: [MatFormFieldModule, MatInputModule, FormsModule, NgIf, CharacterCounterComponent, MatIconModule, AsyncPipe, MatButtonModule, MatTooltipModule]
})
export class TextAreaComponent implements OnInit {

  @Input() textArea!: TextArea;
  @Input() stopEditing:boolean = false;
  @Input() text:string = '';
  @Output() diff = new EventEmitter<number>();

  loading$: Observable<ProgressBarModel>;

  constructor(public layoutElemeneUtil: LayoutElementUtil, private progressbarService:ProgressbarService, private eventBusService: EventBusService) {
    this.loading$ = this.progressbarService.loading$;
  }

  ngOnInit(): void {
    this.fire(this.textArea.content);
  }

  fireKiEvent($event: MouseEvent, shortened: boolean) {
    this.eventBusService.emit(EventBusTypes.KI_REFRESH_EVENT.valueOf(), new KiRefreshEvent(this.textArea.containerId, shortened));
  }

  // todo: Funktioniert nicht, wenn man kopiert
  fire(newObj: any): void {
    /*if(this.stopEditing) {
      this.textArea.maxChars = this.textArea.content?.length;
    } else {
      let contentLength: number = 0;
      if (this.textArea.orgContent && this.textArea.orgContent != undefined) {
        contentLength = this.textArea.orgContent.length;
      }
      let d = newObj.length - contentLength;
      //console.log("NEWOBJ: " + newObj + " TEXTAREA_CONTENT: " + this.textArea.orgContent);

      this.diff.emit(d);
      this.textArea.orgContent = newObj;
    }*/

    let contentLength: number = 0;
    if (this.textArea.orgContent && this.textArea.orgContent != undefined) {
      contentLength = this.textArea.orgContent.length;
    }
    let d = newObj.length - contentLength;
    //console.log("NEW OBJ: " +newObj)
    //if(this.textArea.maxChars && newObj.length >= this.textArea.maxChars) {
      //newObj = newObj.substring(0,this.textArea.maxChars);
      //d = newObj.length - contentLength;
      //console.log("NEW OBJ: " +newObj)
    //}

    if(this.stopEditing && d > 0) {
      //console.log("STOPPPPP -> DIFF: " + d);
      this.textArea.maxChars = newObj.length;
    }
    this.textArea.orgContent = newObj;
    this.diff.emit(d);
  }
}
